export default __webpack_public_path__ + "static/media/qcri.5eb8ca11.PNG";